import React from 'react';
import { View, Image, StyleSheet, TouchableOpacity, TouchableWithoutFeedback } from 'react-native';
import { Text } from './../../components/UI-Components';
import { Surface } from 'react-native-paper';
import { LinearScale } from '@material-ui/icons';


const coursesImg = require('./../../assets/courses.png');
const testSeriesImg = require('./../../assets/testSeries_home.png');


const deviceWidth = 480;
const _width = window.innerWidth;


  
export default class Course extends React.Component {
    render() {
        return(
            <View style={styles.container}>
            {/* <TouchableWithoutFeedback
                onPress={() => this.props.navigation.push('/courseExam')}
                >
                <Surface style={styles.imageWrapper}>
                    <Image source={coursesImg} style={styles.image} />
                    <Text style={styles.title}>COURSES</Text>
                </Surface>
            </TouchableWithoutFeedback> */}
            <TouchableWithoutFeedback
                onPress={() => this.props.navigation.push('/MyTests')}
            >
                <Surface style={styles.imageWrapper}>
                    <Image source={testSeriesImg} style={styles.image} />
                    <View style={styles.titleBox}>
                     <Text style={styles.title}>TEST SERIES</Text>
                     <Text style={styles.subTitle} >Make your preparation easy</Text>
                    </View>
                </Surface>
            </TouchableWithoutFeedback>
            <TouchableWithoutFeedback
                onPress={() => this.props.navigation.push('/libraryExam')}
            >
                <Surface style={styles.imageWrapper}>
                    <Image source={coursesImg} style={styles.image} />
                    <View style={styles.titleBox}>
                     <Text style={styles.title}>Library</Text>
                     <Text style={styles.subTitle} >Make your preparation easy</Text>
                    </View>
                </Surface>
            </TouchableWithoutFeedback>

            </View>
        )
    }
}


const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingHorizontal: 10,
        paddingVertical: 8,
        flexDirection: 'row',
        justifyContent: 'center',
        height: 150,
        width:_width <= 479 ? 180 :  deviceWidth,
        marginTop: 120,      
        alignSelf: 'center' ,
        // width: 400,
        transform: [{ scale: _width >= 578 ? 1.5 : 1 }]
        // transform: LinearScale()
        
    },
    imageWrapper: {
        position: 'relative',       
        width: _width <= 479 ? (_width/2) - 20 : (deviceWidth/2) - 20,
        // alignItems: 'center',
        elevation: 10,
        borderRadius: 10,
        height: '100%',
        cursor: 'pointer',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: _width <= 479 ? 'column' : 'row',
        marginHorizontal: 10
        
    },
    image: {
        width: 150,        
        maxWidth: 180,
        height: 120,
        resizeMode: 'contain',
        // position: 'absolute',
        // zIndex: 1000,
        
        marginTop: _width <= 479 ? -60: 0
    },
    title: {
        fontSize: 18,
        fontWeight: '600',
        marginTop: 'auto',
        marginBottom: 10,
        color: 'rgba(0,0,0,0.7)',
        alignSelf: 'center',
        
    },
    subTitle: {
        fontSize: 11,
        fontWeight: '500',
        marginTop: 'auto',
        marginBottom: 10,
        color: 'rgba(0,0,0,0.7)',
        alignSelf: 'center',
        
    },

    titleBox: {
     alignSelf: 'center',
     flex: 1,
     marginLeft: 10,
     justifyContent :'center',
     flexDirection: 'column'
    }
})


